import { FieldState, FormState } from "formstate";

export class FormClientDetail {
  responsible_person_id = new FieldState("");
  other_responsible_persons_ids = new FieldState<string[]>([]).validators();

  form = new FormState({
    responsible_person_id: this.responsible_person_id,
    other_responsible_persons_ids: this.other_responsible_persons_ids,
  });

  validate = async () => {
    const res = await this.form.validate();

    return res.hasError
      ? null
      : {
          responsible_person_id: this.form.$.responsible_person_id.$,
          other_responsible_persons_ids:
            this.form.$.other_responsible_persons_ids.$,
        };
  };
}
